import React from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import routes from '../routes'
import SchoolInstitutionsView from '../Views/school/SchoolInstitutionsView'
import InstitutionSchoolsView from '../Views/institution/InstitutionSchoolsView'
import MailsListView from '../Views/super-admin/MailsListView'
import ChangelogManagementView from '../Views/super-admin/ChangelogManagementView'
import ChangeLogView from '../Views/shared/ChangeLogView'

const AdminRouter = () => {
  return (
    <Switch>
      <Route path={routes.INSTITUTIONS}>
        <SchoolInstitutionsView />
      </Route>
      <Route path={routes.SCHOOLS}>
        <InstitutionSchoolsView />
      </Route>
      <Route path={routes.MAILS_LIST}>
        <MailsListView />
      </Route>
      <Route path={routes.CHANGELOG_MANAGEMENT}>
        <ChangelogManagementView />
      </Route>
      <Route path={routes.CHANGELOG}>
        <ChangeLogView />
      </Route>
    </Switch>
  )
}

export default withRouter(AdminRouter)
